import { render, staticRenderFns } from "./MemberManagement.vue?vue&type=template&id=022415d4&"
import script from "./MemberManagement.vue?vue&type=script&lang=js&"
export * from "./MemberManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports